/* eslint-disable no-use-before-define */
import React from 'react'
import {Loading, arrayFrom, Disclosures, showModal} from '../../../twd'
import useNews from './use-news'
import Items from './items'
import Paging from './paging'

export default ({modal}) => {
    const { rows, status, error, page, setPage, total } = useNews({modal})

    const n = arrayFrom(rows).length
    const isMore = !modal && n>5

    return (
        <Loading status={status} error={error} >
            <Items rows={rows} modal={modal} />

            <div className="row vertical-offset-xxs">

            <div className="col-xs-6">
                {isMore && <button
                    data-name="municipals-market-news-more-stories-link"
                    className="text-bold link-button"
                    onClick={(e) => showModal('municipals-market-news-modal', { source:e.target, })}>More Stories...</button>}
            </div>
            <div className="col-xs-6 text-right">
                <Disclosures
                    dataName="corporates-market-news-disclosures-link"
                    html={DISCLOSURES} />
            </div>

            </div>

            {modal && <Paging page={page} setPage={setPage} total={total} />}
        </Loading>
    )

}

const DISCLOSURES = `
    Please review <a href="#" style="cursor:pointer"
    onclick="twd.hideModal();twd.openWindow('https://www.lexisnexis.com/en-us/terms/general/default.page', '_blank')">LexisNexis terms and conditions</a>
    in order to access the full text for LexisNexis licensed articles.
`